// @ vendor
const { merge } = require('lodash');

// @ utils
const { APIPost, APIGet } = require('utilities/APIRequestHelper');
const { getLanguage } = require('core/i18n').i18n;
const apiURLBuilder = require('core/apiURLBuilder');

// @ actions
const { requestInsuranceRelatedRNCCurrentState } = require('./insuranceRequestRelatedRNCState');
const { mortgageRequestInsurancesLink } = require('actions/mortgageRequest/mortgageRequestManagerInsuranceRelated');

// @ constants
const { SECOND_STEP, THIRD_STEP } = require('constants/index');
const { INSURANCES_TYPE: { HOME_MORTGAGE_RELATED } } = require('../../insuranceConstants/insuranceRequestTypes');
const { API_FLOW_STEPS, PLANS: { HIGH, BASIC, MEDIUM } } = require('../../insuranceConstants/insuranceRequestHome');
const { INSURANCE_USABILITY_IMPROVEMENTS } = require('constants/flagBasedFeatures');
const {
    INSURANCE_REQUEST_RELATED_RNC_SIMULATION_LINK_S3_CLIENT_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_SIMULATION_LINK_S3_CLIENT_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_SIMULATION_LINK_S3_CLIENT_FAILURE,
    INSURANCE_REQUEST_RELATED_RNC_COVERAGES_QUOTATION_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_COVERAGES_QUOTATION_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_COVERAGES_QUOTATION_FAILURE,
    INSURANCE_REQUEST_RELATED_RNC_CURRENT_STATE_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_CURRENT_STATE_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_CURRENT_STATE_FAILURE,
    INSURANCE_REQUEST_RELATED_RNC_SELECT_PLAN_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_SELECT_PLAN_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_SELECT_PLAN_FAILURE,
    INSURANCE_REQUEST_RELATED_RNC_GET_COVERAGES_AND_PLANS_TABLE_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_GET_COVERAGES_AND_PLANS_TABLE_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_GET_COVERAGES_AND_PLANS_TABLE_FAILURE,
    INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_BASIC_DATA_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_BASIC_DATA_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_MEDIUM_DATA_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_MEDIUM_DATA_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_HIGH_DATA_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_HIGH_DATA_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_DATA_FAILURE,
    INSURANCE_REQUEST_SELECT_BASIC_PLAN,
    INSURANCE_REQUEST_RELATED_RNC_SELECTED_PLAN,
    INSURANCE_REQUEST_RELATED_RNC_SET_LINKING_SUCCESS_TO_INITIAL,
    INSURANCE_REQUEST_RELATED_RNC_SIMULATION_LINK_S3_CLIENT_INITIAL_VALUE_IN_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_SAVE_STEP_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_SAVE_STEP_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_SAVE_STEP_FAILURE
} = require('../../insuranceConstants/actionTypes');
const {
    PRE_CONTRACTUAL_RELATED_INSURANCE_MAIL,
} = require('constants/flagBasedFeatures');

const linkClientInProgress = () => ({
    type: INSURANCE_REQUEST_RELATED_RNC_SIMULATION_LINK_S3_CLIENT_REQUEST
});

const linkClientSuccess = () => ({
    type: INSURANCE_REQUEST_RELATED_RNC_SIMULATION_LINK_S3_CLIENT_SUCCESS
});

const linkClientFailure = error => ({
    type: INSURANCE_REQUEST_RELATED_RNC_SIMULATION_LINK_S3_CLIENT_FAILURE,
    data: { error }
});

const setLinkedSimulationToInitial = () => ({
    type: INSURANCE_REQUEST_RELATED_RNC_SET_LINKING_SUCCESS_TO_INITIAL,
});

const requestQuotationInProgress = (quotationRequestId) => ({
    type: INSURANCE_REQUEST_RELATED_RNC_COVERAGES_QUOTATION_REQUEST,
    data: { quotationRequestId }
});

const requestQuotationSuccess = data => ({
    type: INSURANCE_REQUEST_RELATED_RNC_COVERAGES_QUOTATION_SUCCESS,
    data
});

const requestQuotationFailure = error => ({
    type: INSURANCE_REQUEST_RELATED_RNC_COVERAGES_QUOTATION_FAILURE,
    data: { error }
});

const requestSelectPlanSuccess = plan => ({
    type: INSURANCE_REQUEST_RELATED_RNC_SELECT_PLAN_SUCCESS,
    data: {
        plan
    }
});

const requestSelectPlanInProgress = () => ({
    type: INSURANCE_REQUEST_RELATED_RNC_SELECT_PLAN_REQUEST
});

const requestSelectPlanFailure = error => ({
    type: INSURANCE_REQUEST_RELATED_RNC_SELECT_PLAN_FAILURE,
    data: { error }
});

const coveragesAndPlansDataInProgress = () => ({
    type: INSURANCE_REQUEST_RELATED_RNC_GET_COVERAGES_AND_PLANS_TABLE_REQUEST
});

const coveragesAndPlansDataSuccess = data => ({
    type: INSURANCE_REQUEST_RELATED_RNC_GET_COVERAGES_AND_PLANS_TABLE_SUCCESS,
    data
});

const coveragesAndPlansDataFailure = error => ({
    type: INSURANCE_REQUEST_RELATED_RNC_GET_COVERAGES_AND_PLANS_TABLE_FAILURE,
    data: { error }
});

const coveragesAndPlansDetailsBasicInProgress = () => ({
    type: INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_BASIC_DATA_REQUEST,
});

const coveragesAndPlansDetailsBasicSuccess = data => ({
    type: INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_BASIC_DATA_SUCCESS,
    data
});

const coveragesAndPlansDetailsMediumInProgress = () => ({
    type: INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_MEDIUM_DATA_REQUEST,
});

const coveragesAndPlansDetailsMediumSuccess = data => ({
    type: INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_MEDIUM_DATA_SUCCESS,
    data
});

const coveragesAndPlansDetailsHighInProgress = () => ({
    type: INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_HIGH_DATA_REQUEST,
});

const coveragesAndPlansDetailsHighSuccess = data => ({
    type: INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_HIGH_DATA_SUCCESS,
    data
});

const coveragesAndPlansDetailsFailure = error => ({
    type: INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_DATA_FAILURE,
    data: { error }
});

const selectPlanInRelatedWizardStep3 = insurancePlan => ({
    type: INSURANCE_REQUEST_RELATED_RNC_SELECTED_PLAN,
    data: {
        insurancePlan
    }
});

const linkClientSuccessInitialState = () => ({
    type: INSURANCE_REQUEST_RELATED_RNC_SIMULATION_LINK_S3_CLIENT_INITIAL_VALUE_IN_SUCCESS,
});

const saveStepRequest = () => ({
    type: INSURANCE_REQUEST_RELATED_RNC_SAVE_STEP_REQUEST
});

const saveStepSuccess = () => ({
    type: INSURANCE_REQUEST_RELATED_RNC_SAVE_STEP_SUCCESS
});

const saveStepFailure = error => ({
    type: INSURANCE_REQUEST_RELATED_RNC_SAVE_STEP_FAILURE,
    data: { error }
});

const requestInsuranceCurrentStateInProgress = () => ({
    type: INSURANCE_REQUEST_RELATED_RNC_CURRENT_STATE_REQUEST
});

const requestInsuranceCurrentStateSuccess = current => ({
    type: INSURANCE_REQUEST_RELATED_RNC_CURRENT_STATE_SUCCESS,
    data: { current }
});

const requestInsuranceCurrentStateFailure = error => ({
    type: INSURANCE_REQUEST_RELATED_RNC_CURRENT_STATE_FAILURE,
    data: { error }
});

const saveStep = current => (dispatch, getState) => {
    const appraisalProperty = getState().insuranceRequestRelatedRNCState.getIn(['appraisal', 'property']);
    const immStep = getState().insuranceRequestRelatedRNCWizard.getIn(['steps', THIRD_STEP]);

    const newState = {
        flowData: { uiStep: API_FLOW_STEPS.STEP_3 },
        home: {
            number: appraisalProperty && appraisalProperty.get('streetNumber'),
            population: immStep.get('population'),
            road: appraisalProperty && appraisalProperty.get('street')
        },
        payment: {
            paymentType: immStep.get('paymentType')
        },
        startDate: null
    }

    dispatch(saveStepRequest());

    const requestInformation = {
        query: merge({}, current, newState)
    };

    return APIPost(
        dispatch,
        apiURLBuilder.getURL('insuranceRequestStateRequest', { id: current.id }),
        requestInformation
    )
        .then(() => dispatch(saveStepSuccess()))
        .catch(response => {
            if (!!response.error) {
                dispatch(saveStepFailure(response.error));
            } else {
                throw response;
            }
        });
};

const requestInsuranceCurrentState = () => (dispatch, getState) => {
    const immStep = getState().insuranceRequestRelatedRNCWizard.getIn(['steps', THIRD_STEP]);
    const insuranceId = immStep.getIn(['quotationData', 'idInsurance']);

    dispatch(requestInsuranceCurrentStateInProgress());

    return APIGet(
        dispatch,
        apiURLBuilder.getURL('insuranceRequestStateRequest', { id: insuranceId })
    )
        .then(response => {
            dispatch(requestInsuranceCurrentStateSuccess(response.data));
            dispatch(saveStep(response.data));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(requestInsuranceCurrentStateFailure(response.error));
            } else {
                throw response;
            }
        });
};

const linkClient = plan => (dispatch, getState) => {
    const {
        flagBasedFeatures,
        insuranceRequestModify,
        insuranceRequestRelatedRNCState,
        insuranceRequestRelatedRNCWizard,
    } = getState();

    const insuranceIsBeingModified = insuranceRequestModify.get('insuranceIsBeingModified');
    const isLinkingInProgress = insuranceRequestRelatedRNCWizard.getIn(["steps", THIRD_STEP, "isLinkingInProgress"])

    if (!isLinkingInProgress) {
        dispatch(linkClientInProgress());

        const insuranceId = insuranceRequestRelatedRNCWizard.getIn(["steps", THIRD_STEP, "quotationData", "idInsurance"]);
        const previousInsurance = insuranceIsBeingModified ? null : insuranceRequestRelatedRNCState.getIn(['data', 'id']) || null;
        const expedientId = insuranceRequestRelatedRNCState.get('idExpediente');
        const draft = insuranceIsBeingModified;
        const language = getLanguage().toUpperCase();

        let appraisal = false;
        let propertyId = null;

        if (insuranceRequestRelatedRNCState.getIn(['appraisal', 'afterAppraisal'])) {
            const propertyMortgage = insuranceRequestRelatedRNCState.getIn(['appraisal', 'property'])

            appraisal = insuranceRequestRelatedRNCState.getIn(['appraisal', 'afterAppraisal']);
            propertyId = propertyMortgage.get('id');
        }

        const immStep = getState().insuranceRequestRelatedRNCWizard.getIn(['steps', THIRD_STEP]);
        const paymentType = immStep.get('paymentType') || null;

        const params = {
            query: {
                appraisal,
                draft,
                expedientId,
                insuranceId,
                language,
                plan,
                propertyId,
                previousInsurance,
                paymentType,
                isClientWithoutAccounts: true
            }
        };

        if (flagBasedFeatures.get(PRE_CONTRACTUAL_RELATED_INSURANCE_MAIL)) {
            if (__CONTACT_CENTER__) {
                params['header'] = {
                    version: '3',
                }
            } else {
                params['header'] = {
                    version: '2',
                }
            }
        }

        const insuranceIdDraft = insuranceIsBeingModified ? insuranceId : null;

        return APIPost({
            dispatch,
            endpoint: 'insuranceRequestRelatedSimulationLinkClient',
            params
        })
            .then(() => {
                dispatch(mortgageRequestInsurancesLink(true, false));
                dispatch(linkClientSuccess());
                dispatch(requestInsuranceRelatedRNCCurrentState(insuranceIdDraft));
                dispatch(requestInsuranceCurrentState());
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(linkClientFailure(response.error));
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve();
    }
};

const basicPlanAcceptanceModal = () => ({
    type: INSURANCE_REQUEST_SELECT_BASIC_PLAN,
});

const insuranceSelectPlan = plan => (dispatch, getState) => {
    const immStep = getState().insuranceRequestRelatedRNCWizard.getIn(['steps', THIRD_STEP]);

    if (!immStep.get('isFetchingSelectPlan')) {
        dispatch(requestSelectPlanInProgress());
        const params = {
            query: {
                plan,
                simulationToken: immStep.getIn(['quotationData', 'simulationToken'])
            }
        };

        return APIPost({
            dispatch,
            endpoint: 'insuranceRequestSelectPlan',
            params
        })
            .then(dispatch(requestSelectPlanSuccess(plan)))
            .catch(response => {
                if (!!response.error) {
                    dispatch(requestSelectPlanFailure(response.error));
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve();
    }
};

const getPopulationLabel = immStep2 => {
    const populationValue = immStep2.get('populationValue');
    if (populationValue) {
        const immPopulation = immStep2.get('populationOptions').
            find(immPopulation => populationValue === immPopulation.get('value'));
        return !!immPopulation && immPopulation.get('label');
    }
}

const getQuotationData = hasSimulationChanged => (dispatch, getState) => {
    const { insuranceRequestRelatedRNCState, insuranceRequestRelatedRNCWizard } = getState();
    const immStep2 = insuranceRequestRelatedRNCWizard.getIn(['steps', SECOND_STEP]);
    const immStep3 = insuranceRequestRelatedRNCWizard.getIn(['steps', THIRD_STEP]);
    const expedientId = insuranceRequestRelatedRNCState.get('idExpediente');
    const afterAppraisal = insuranceRequestRelatedRNCState.getIn(['appraisal', 'afterAppraisal']);
    const appraisalSize = insuranceRequestRelatedRNCState.getIn(['appraisal', 'property', 'appraisalSize']);

    const populationLabel = getPopulationLabel(immStep2);
    const params = {
        query: {
            continent: immStep2.get('continent'),
            content: immStep2.get('content'),
            postalCode: immStep2.get('postalCode'),
            population: populationLabel,
            propertyCharacter: immStep2.get('propertyCharacter'),
            propertyType: immStep2.get('propertyType'),
            propertyUsage: immStep2.get('propertyUsage'),
            size: afterAppraisal ? appraisalSize || 0 : immStep2.get('size'),
            relatedInformation: {
                appraisal: false,
                expedientId,
                insuranceId: null,
                propertyId: null,
                isClientWithoutAccounts: true
            },
        }
    };

    if (
        !!insuranceRequestRelatedRNCState && afterAppraisal
    ) {
        const propertyMortgage = insuranceRequestRelatedRNCState.getIn(['appraisal', 'property'])
        const propertyMortgageId = propertyMortgage.get("id")
        params.query.relatedInformation.appraisal = true;
        params.query.relatedInformation.propertyId = propertyMortgageId;
    }

    const quotationRequestId = Math.random()
    dispatch(requestQuotationInProgress(quotationRequestId));

    return APIPost({
        dispatch,
        endpoint: 'insuranceRequestRelatedQuotation',
        params
    })
        .then(response => {
            const insuranceRequestRelatedRNCWizardUpdate = getState().insuranceRequestRelatedRNCWizard
            const stateQuotationRequestId = insuranceRequestRelatedRNCWizardUpdate.getIn(['steps', THIRD_STEP, 'quotationRequestId'])

            if (quotationRequestId === stateQuotationRequestId) {
                dispatch(requestQuotationSuccess(response.data));
                if (immStep3.get('insurancePlan')) {
                    if (hasSimulationChanged) {
                        dispatch(requestSelectPlanSuccess(''));
                    }
                }
            }
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(requestQuotationFailure(response.error));
            } else {
                throw response;
            }
        });
};

const getCoveragesAndPlansData = () => dispatch => {
    dispatch(coveragesAndPlansDataInProgress());

    return APIGet({
        dispatch,
        endpoint: 'insuranceRequestCoveragesAndPlans'
    })
        .then(response => {
            dispatch(coveragesAndPlansDataSuccess(response.data));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(coveragesAndPlansDataFailure(response.error));
            }
        })
};

const getCoveragesAndPlansDetailsData = (usage, character, plan = HIGH) => (dispatch, getState) => {
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const nextPlan = plan === HIGH ? MEDIUM : BASIC;
    const actions = {
        HIGH: {
            inProgress: coveragesAndPlansDetailsHighInProgress,
            success: coveragesAndPlansDetailsHighSuccess
        },
        MEDIUM: {
            inProgress: coveragesAndPlansDetailsMediumInProgress,
            success: coveragesAndPlansDetailsMediumSuccess
        },
        BASIC: {
            inProgress: coveragesAndPlansDetailsBasicInProgress,
            success: coveragesAndPlansDetailsBasicSuccess
        }
    };

    dispatch(actions[plan].inProgress());
    const params = {
        query: {
            propertyUsage: usage,
            insurancePlan: plan,
            propertyCharacter: character,
            homeInsuranceType: HOME_MORTGAGE_RELATED
        }
    };
    if (immFlagBasedFeatures.get(INSURANCE_USABILITY_IMPROVEMENTS)) {
        params['header'] = {
            version: '2',
        }
    }
    return APIGet({
        dispatch,
        endpoint: 'insuranceRequestCoveragesAndPlansDetails',
        params
    })
        .then(response => {
            dispatch(actions[plan].success(response.data));
            if (nextPlan !== plan) {
                dispatch(getCoveragesAndPlansDetailsData(usage, character, nextPlan));
            }
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(coveragesAndPlansDetailsFailure(response.error));
            } else {
                throw response;
            }
        });
};

module.exports = {
    basicPlanAcceptanceModal,
    linkClient,
    getQuotationData,
    insuranceSelectPlan,
    getCoveragesAndPlansData,
    getCoveragesAndPlansDetailsData,
    selectPlanInRelatedWizardStep3,
    setLinkedSimulationToInitial,
    linkClientSuccessInitialState
};
